import {
  GET_DEVICE_INVENTORY,
  GET_SIM_INVENTORY,
  GET_ACTIVE_LINES_INVENTORY,
} from '../actions/types'

const initialState = {
  deviceInventory: {},
  simInventory: {},
  activeLinesInventory: {},
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case GET_DEVICE_INVENTORY:
      return {
        ...state,
        deviceInventory: action.deviceInventory,
      }
    case GET_SIM_INVENTORY:
      return {
        ...state,
        simInventory: action.simInventory,
      }
    case GET_ACTIVE_LINES_INVENTORY:
      return {
        ...state,
        activeLinesInventory: action.activeLinesInventory,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/ducks/reducers/inventory.js